var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('HomeHeader',{staticClass:"home-header"}),_vm._v(" "),_c('HomeNav',{staticClass:"home-nav"}),_vm._v(" "),_c('div',{staticClass:"join"},[_c('Fold',{attrs:{"list":_vm.foldList}}),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{staticClass:"right"})],1)],1),_vm._v(" "),_c('HomeFooter')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c7685ec","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/join/Join.vue
// module id = null
// module chunks = 